"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
var Checkbox_module_css_1 = __importDefault(require("./Checkbox.module.css"));
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox.prototype.render = function () {
        var _a = this.props, text = _a.text, checked = _a.checked, onClick = _a.onClick, _b = _a.id, id = _b === void 0 ? "" : _b;
        return (react_1.default.createElement("label", { className: Checkbox_module_css_1.default.root, onClick: onClick, id: id },
            react_1.default.createElement("input", { className: "form-do-not-disable ".concat(Checkbox_module_css_1.default.input), type: "checkbox", checked: checked }),
            react_1.default.createElement(Icon_1.Icon, { className: Checkbox_module_css_1.default.icon, width: 18, height: 18 }),
            text && react_1.default.createElement("p", { className: Checkbox_module_css_1.default.text }, text)));
    };
    return Checkbox;
}(react_1.Component));
exports.Checkbox = Checkbox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tib3guanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0Rpc2Nsb3N1cmVNb2RhbC9wYXJ0cy9DaGVja2JveC9DaGVja2JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBc0M7QUFDdEMsK0JBQTJCO0FBQzNCLDhFQUEwQztBQVUxQztJQUE4Qiw0QkFBb0I7SUFBbEQ7O0lBZUEsQ0FBQztJQWRVLHlCQUFNLEdBQWI7UUFDVSxJQUFBLEtBQW9DLElBQUksQ0FBQyxLQUFLLEVBQTdDLElBQUksVUFBQSxFQUFFLE9BQU8sYUFBQSxFQUFFLE9BQU8sYUFBQSxFQUFFLFVBQU8sRUFBUCxFQUFFLG1CQUFHLEVBQUUsS0FBYyxDQUFBO1FBQ3BELE9BQU8sQ0FDSCx5Q0FBTyxTQUFTLEVBQUUsNkJBQU0sQ0FBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUUsRUFBRTtZQUNuRCx5Q0FDSSxTQUFTLEVBQUUsOEJBQXVCLDZCQUFNLENBQUMsS0FBSyxDQUFFLEVBQ2hELElBQUksRUFBQyxVQUFVLEVBQ2YsT0FBTyxFQUFFLE9BQU8sR0FDbEI7WUFDRiw4QkFBQyxXQUFJLElBQUMsU0FBUyxFQUFFLDZCQUFNLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsTUFBTSxFQUFFLEVBQUUsR0FBSTtZQUN0RCxJQUFJLElBQUkscUNBQUcsU0FBUyxFQUFFLDZCQUFNLENBQUMsSUFBSSxJQUFHLElBQUksQ0FBSyxDQUMxQyxDQUNYLENBQUE7SUFDTCxDQUFDO0lBQ0wsZUFBQztBQUFELENBQUMsQUFmRCxDQUE4QixpQkFBUyxHQWV0QztBQWZZLDRCQUFRIn0=